import { exhaustMap } from 'rxjs';
import { inject } from '@angular/core';
import { VesselParticularsService } from '@navstation-portal/vessels/data-access/service';
import { VesselParticularsStoreState } from '@navstation-portal/vessels/data-model/vessel';
import { mapResponse } from '@ngrx/operators';
import { signalStoreFeature, type } from '@ngrx/signals';
import { Events, withEventHandlers } from '@ngrx/signals/events';
import { vesselParticularsEvents } from './vessel-particulars-events';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withVesselParticularsEffects<_>() {
  return signalStoreFeature(
    type<{ state: VesselParticularsStoreState }>(),
    withEventHandlers(() => {
      const events = inject(Events);
      const vesselParticularsService = inject(VesselParticularsService);

      return {
        fetchVesselParticulars$: events.on(vesselParticularsEvents.fetchVesselParticulars).pipe(
          exhaustMap(({ payload: vesselId }) =>
            vesselParticularsService.getVesselParticulars(vesselId).pipe(
              mapResponse({
                next: (vesselParticulars) => vesselParticularsEvents.fetchVesselParticularsSuccess(vesselParticulars),
                error: (err: Error) => vesselParticularsEvents.fetchVesselParticularsFailed(err),
              })
            )
          )
        ),
      };
    })
  );
}
